import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { EmployeeDto } from 'src/api';

export interface EmployeesState extends EntityState<EmployeeDto, number> {
  filters: {
    searchTerm: string | null;
  };
}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'employees', cache: { ttl: 3600000 } })
export class EmployeesStore extends EntityStore<EmployeesState> {
  constructor() {
    super({
      filters: {
        searchTerm: null,
      },
    });
  }
}
